import React from "react";

export default function SpaceGuestAuthLayout({ children }: { children: React.ReactNode }) {
    return (
        <div
            className={`h-screen w-screen bg-[#F3F3F3] bg-[url('https://storage.googleapis.com/heysynth_files/app/spaces-bg.png')] bg-cover bg-no-repeat`}
        >
            <div className="backdrop-blur-sm bg-[rgba(0,0,0,0.4)] w-full h-full flex items-center justify-center">
                {children}

                <div className="absolute bg-white rounded-lg p-2 w-fit bottom-4 left-auto right-auto flex items-center justify-center gap-2">
                    <p className="text-sm font-rocGroteskMedium">Powered by</p>
                    <img
                        src="https://storage.googleapis.com/heysynth_files/synth_web/HeySynth%20Logo.svg"
                        alt="Powered by"
                        className="w-[40px]"
                    />
                </div>
            </div>
        </div>
    );
}
